import { createReducer } from '@reduxjs/toolkit';

import getWarehouseDuplicates from '../../../thunks/coilovers/warehouse/getWarehouseDuplicates';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const getWarehouseDuplicatesReducer = createReducer(initialState, {
  [getWarehouseDuplicates.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getWarehouseDuplicates.fulfilled]: (state, {
    payload
  }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [getWarehouseDuplicates.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getWarehouseDuplicatesReducer;
